module.exports = __webpack_public_path__ + "img/bg_1.6ae6f3bc.png";